(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Contacts', Contacts);

    Contacts.$inject = ['$resource'];

    function Contacts ($resource) {
        var resourceUrl =  'api/contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'guarantor': { url: 'api/contacts/guarantor/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/contacts/by-chart/filter', method: 'GET', isArray: true},
            'findAllGuarantors': { url: 'api/contacts/guarantor/all/:id', method: 'GET', isArray: true},
            'findAllByFacility': { url: 'api/contacts/by-facility/filter', method: 'GET', isArray: true}
        });
    }
})();
